import styled from 'styled-components'

export default styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.85);
  z-index: -10;
`
